import { TransactionType, TransactionStatus } from 'src/type/transaction';

export const topupWithdrawTypeOptions = [
  {
    value: 'all',
    label: 'ทุกประเภท',
  },
  {
    value: TransactionType.TOPUP_CREDIT,
    label: 'รายการเติม',
  },
  {
    value: TransactionType.WITHDRAW_CREDIT,
    label: 'รายการถอน',
  },
];

export const typeLabel = (type: TransactionType | string) =>
  topupWithdrawTypeOptions.find((item) => item.value === type)?.label || '';

export const txAction = (type?: TransactionType) => {
  switch (type) {
    case TransactionType.TOPUP_CREDIT:
      return 'เติม';
    case TransactionType.WITHDRAW_CREDIT:
      return 'ถอน';
    default:
      return '';
  }
};

export const statusAction = (status?: TransactionStatus) => {
  switch (status) {
    case TransactionStatus.SUCCESS:
      return 'อนุมัติ';
    case TransactionStatus.REJECTED:
    case TransactionStatus.CANCEL:
      return 'ปฎิเสธ';
    default:
      return '';
  }
};

export const bankLabel = (type: TransactionType) => {
  switch (type) {
    case TransactionType.TOPUP_CREDIT:
      return 'ระบบ';
    case TransactionType.WITHDRAW_CREDIT:
      return 'ลูกค้า';
    default:
      return '-';
  }
};
